import { Settings, ArrowLeft } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setStoreCategory, setShowMenu, setHelpMenu } from '../Redux/store';
import HelpButton from '../components/HelpButton';

const TITLED_PAGES = ['calendar', 'chats', 'store'];

const CATEGORY_TITLES = {
  ip: 'For Intended Parents',
  expecting: 'For New / Expecting Parents',
  donor: 'For Donors',
};

function TopBar() {
  const dispatch = useDispatch();
  const page = useSelector((s) => s.ui.currentPage);
  const storeCategory = useSelector((s) => s.ui.storeCategory);
  const isStoreCategoryOpen = page === 'store' && storeCategory;
  const showTitle = isStoreCategoryOpen || TITLED_PAGES.includes(page);

  if (showTitle) {
    return (
      <header className="shrink-0 flex h-14 items-center justify-between bg-background px-4">
        {isStoreCategoryOpen ? (
          <>
            <button
              onClick={() => dispatch(setStoreCategory(null))}
              className="flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground hover:bg-muted"
            >
              <ArrowLeft size={20} />
            </button>
            <h1 className="text-base font-semibold text-foreground">
              {CATEGORY_TITLES[storeCategory] ?? 'Store'}
            </h1>
            <div className="w-9" />
          </>
        ) : (
          <>
            <HelpButton helpKey={page} />
            <h1 className="text-base font-semibold text-foreground capitalize">{page}</h1>
            <button
              onClick={() => dispatch(setShowMenu(true))}
              className="flex h-9 w-9 items-center justify-center bg-primary text-primary-foreground"
              style={{ clipPath: 'polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%)' }}
            >
              <Settings size={16} />
            </button>
          </>
        )}
      </header>
    );
  }

  return (
    <header className="pointer-events-none absolute top-0 left-0 right-0 z-20 flex items-center justify-between px-4 pt-3">
      <HelpButton helpKey={page} />
      <button
        onClick={() => dispatch(setShowMenu(true))}
        className="pointer-events-auto flex h-9 w-9 items-center justify-center bg-primary text-primary-foreground"
        style={{ clipPath: 'polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%)' }}
      >
        <Settings size={16} />
      </button>
    </header>
  );
}

export default TopBar;
